export const OFFICE_DESIGNS = [
  {
    id: "DESIGN_300",
    title: "Model Design 1 - 300 Sq.ft",
    area: 300,
    width: 15,
    length: 20,
    sizeLabel: "15 × 20",
  },
  {
    id: "DESIGN_500",
    title: "Model Design 2 - 500 Sq.ft",
    area: 500,
    width: 26,
    length: 19,
    sizeLabel: "26 × 19",
  },
  {
    id: "DESIGN_850",
    title: "Model Design 3 - 850 Sq.ft",
    area: 850,
    width: 34,
    length: 25,
    sizeLabel: "34 × 25",
  },
];